import{fetch as r,getEndPoint as e}from"@liff/server-api";function f(){return r(e("profile"))}export{f as getProfile};
